import { Notification, NotificationLink, View } from '../types';

type GoToFn = (view: View, params?: any) => void;

export function openNotification(
  notification: Notification,
  goTo: GoToFn
) {
  const entityCatchId = notification.entity?.catchId ? String(notification.entity.catchId) : '';

  if (entityCatchId) {
    goTo(View.LogCatch, { openInsight: true, catchId: entityCatchId });
    return;
  }

  const link = notification.link;

  if (!link) {
    console.warn('[notifications] missing link', notification);
    return;
  }

  const { view, targetId, subTargetId } = link;

  switch (view) {

    case View.Community:
      goTo(View.Community, {
        focusPostId: targetId,
        focusCommentId: subTargetId
      });
      break;

    case View.Bazaar: {
      const isBazaarMessage = String((notification as any)?.type || '').toUpperCase() === 'BAZAAR_MESSAGE';
      goTo(View.Bazaar, isBazaarMessage
        ? { itemId: targetId, threadId: subTargetId }
        : { itemId: targetId, offerId: subTargetId });
      break;
    }

    case View.Receipt:
      goTo(View.Receipt, {
        txId: targetId
      });
      break;

    case View.Events:
      goTo(View.Events, {
        tournamentId: targetId
      });
      break;

    case View.LicenseDetail:
      goTo(View.LicenseDetail, {
        licenseId: targetId
      });
      break;

    case View.LogCatch:
      goTo(View.LogCatch, {
        openInsight: true,
        catchId: targetId
      });
      break;

    case View.CatchHistory:
      goTo(View.LogCatch, {
        openInsight: true,
        catchId: targetId
      });
      break;


    case View.Crew:
      if (String((notification as any)?.type || '').toUpperCase() === 'CREW_MESSAGE') {
        goTo(View.Crew, {
          dmId: targetId,
          dmUid: subTargetId,
        });
      } else {
        goTo(View.Crew, {
          crewId: targetId,
          postId: subTargetId,
        });
      }
      break;

    case View.PublicProfile:
      goTo(View.PublicProfile, {
        userId: targetId,
        targetUserId: targetId,
      });
      break;

    case View.Profile:
      goTo(View.PublicProfile, {
        userId: targetId,
        targetUserId: targetId,
      });
      break;

    default:
      goTo(view);
  }
}